// extracted by mini-css-extract-plugin
export var page = "index-module--page--xNDgj";
export var content = "index-module--content--7WlJI";